import NavStore from 'stores/NavStore';
import React from 'react';
import connectToStores from 'alt-utils/lib/connectToStores';
import GridOverrideNav, {
  overrideName as resultGrid,
} from 'components/nav/renderers/GridOverrideNav';
import ScorecardOverrideNav, {
  overrideName as scorecard,
} from 'components/nav/renderers/ScorecardOverrideNav';
import ScorecardChooserOverrideNav, {
  overrideName as scorecardChooser,
} from 'components/nav/renderers/ScorecardChooserOverrideNav';
import LiveCoachingOverrideNav, {
  overrideName as liveCoaching,
} from 'components/nav/renderers/LiveCoachingOverrideNav';

class OverrideNavContainer extends React.PureComponent {
  static getStores() {
    return [NavStore];
  }

  static getPropsFromStores() {
    const navStoreState = NavStore.getState();

    return {
      navOverrideProps: navStoreState.navOverrideProps,
      name: navStoreState.navOverride,
    };
  }

  render() {
    const {name, navOverrideProps: props} = this.props;

    if (!name) return null;

    if (name === resultGrid) return <GridOverrideNav {...props} />;
    if (name === scorecard) return <ScorecardOverrideNav {...props} />;
    if (name === scorecardChooser) return <ScorecardChooserOverrideNav {...props} />;
    if (name === liveCoaching) return <LiveCoachingOverrideNav {...props} />;

    console.error("override nav couldn't display. unknown type " + name);
    return null;
  }
}

export default connectToStores(OverrideNavContainer);
